export class Answer{
    metaName = ""
    questionId = 0
    answerTxt = ""
}